import React from 'react';

import { Box, Card, Table } from '@betterment/samba-react';

import { OnDemandBillingTableHeader } from './BulkFeeIntentHeader';
import { BulkFeeIntentHeaderCell } from './BulkFeeIntentHeaderCell';
import { BulkFeeIntentsLoaded } from './BulkFeeIntentsLoaded';
import { BulkFeeIntentLoading } from './BulkFeeIntentsLoading';

import { BulkFeeIntent, BulkFeeIntentsColumns } from '../data';

type BulkFeeIntentsProps = {
  bulkFeeIntents: BulkFeeIntent[];
  isLoading?: boolean;
  pageSize?: number;
};

export const BulkFeeIntentsTable: React.FC<BulkFeeIntentsProps> = ({
  bulkFeeIntents,
  isLoading = false,
  pageSize = 10,
}) => {
  const COLUMNS: BulkFeeIntentsColumns[] = [
    { name: 'Submitted on', css: { maxWidth: '172px', pr: 'space.200', whiteSpace: 'nowrap' } },
    { name: 'Name', css: { pr: 'space.200' } },
    { name: 'Number of fees and status', css: { maxWidth: '240px', pr: 'space.200', whiteSpace: 'nowrap' } },
    { name: '' },
  ];

  return (
    <Card css={{ px: 'space.300', pt: 'space.300', pb: 'space.150', border: 'none' }}>
      <OnDemandBillingTableHeader />
      <Box css={{ overflowX: 'auto' }}>
        <Table aria-label="onDemandBillingTable">
          <Table.Header>
            <Table.Row>
              {COLUMNS.map(col => (
                <BulkFeeIntentHeaderCell key={col.name} column={col} />
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {isLoading ? (
              <BulkFeeIntentLoading columns={COLUMNS} pageSize={pageSize} />
            ) : (
              <BulkFeeIntentsLoaded bulkFeeIntents={bulkFeeIntents} />
            )}
          </Table.Body>
        </Table>
      </Box>
    </Card>
  );
};
